/**
 * YazioSyncPage - Router wrapper for Yazio Sync
 * Provides data and renders the sync content
 */

import React from "react";

import { YazioSyncTab } from "../organisms/YazioSyncTab";

export const YazioSyncPage: React.FC = () => {
  return <YazioSyncTab />;
};
